var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.media')) + "\n      ")]), _c('v-spacer')], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-card', {
    class: {
      'mr-3': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "pink darken-2",
      "to": {
        name: 'camera',
        params: {
          media: 'photo'
        }
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("photo_camera")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.takePhoto')) + "\n            ")])], 1)], 1)], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "uploadButton btn-file",
    attrs: {
      "color": "blue darken-2"
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("attach_file")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("Upload Photos")]), _c('input', {
    ref: "photoFiles",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFiles
    }
  })], 1)], 1)], 1)], 1), _vm.uploadProgress ? _c('v-layout', {
    attrs: {
      "mb-3": "",
      "mt-1": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "30",
      "color": "orange"
    },
    model: {
      value: _vm.uploadProgress,
      callback: function callback($$v) {
        _vm.uploadProgress = $$v;
      },
      expression: "uploadProgress"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.uploadProgress) + "%\n        ")])], 1)], 1) : _vm._e(), _c('media-list', {
    attrs: {
      "mediaItems": _vm.getMediaList(_vm.callDetail)
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }